import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="togglebutton"
export default class extends Controller {
  static targets = ["button"];

  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const trimester = urlParams.get('trimester');

    if (trimester) {
      this.updateButtonStyle(trimester);
    }
  }

  updateButtonStyle(trimester) {
    this.buttonTargets.forEach((button) => {
      button.classList.remove("bg-gray-700");
      if (button.getAttribute('data-trimester') === trimester) {
        button.classList.add("bg-gray-700");
      }
    });

  }
}
